import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { DropdownItem, DropdownMenu } from "reactstrap";
import { isLocal, domain } from "../../config";
import { logout } from "../../actions/user";
import DropdownInfo from "./_dropdownInfo";
import { getMenuCounters } from "../../utils/Api";

const Indicator = styled.span`
  position: relative;
  top: -8px;
  left: 5px;
  height: 15px;
  width: 15px;
  padding: 2px;
  display: inline-block;
  color: #000;
  background-color: red;
  border-radius: 100%;
  font-size: 9px;
  text-align: center;
`;

const path = isLocal ? "//localhost:3002/#" : `${domain}/company/#`;

const mapStateToProps = ({ user: { permissions, options } }) => ({
  permissions: permissions || [],
  allow_chat: options.allow_chat,
  hide_links_on_learning: options.hide_links_on_learning,
  hide_link_add_course: options.hide_link_add_course,
  hide_link_my_courses: options.hide_link_my_courses,
  hide_link_my_chats: options.hide_link_my_chats,
  hide_link_my_certs: options.hide_link_my_certs,
  hide_link_my_picts: options.hide_link_my_picts,
  hide_link_my_notes: options.hide_link_my_notes,
  hide_link_change_pass: options.hide_link_change_pass,
  hide_link_settings: options.hide_link_settings,
  hide_link_infoserv: options.hide_link_infoserv,
  hide_link_infoserv_info: options.hide_link_infoserv_info,
  hide_link_infoserv_serv: options.hide_link_infoserv_serv,
  hide_link_infoserv_faq: options.hide_link_infoserv_faq,
  hide_link_infoserv_contact: options.hide_link_infoserv_contact,
  all_in_one_tab: options.all_in_one_tab,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutAction: logout,
    },
    dispatch
  );

const Menu = ({
  permissions,
  allow_chat,
  hide_links_on_learning,
  hide_link_add_course,
  hide_link_my_courses,
  hide_link_my_chats,
  hide_link_my_certs,
  hide_link_my_picts,
  hide_link_my_notes,
  hide_link_change_pass,
  hide_link_settings,
  hide_link_infoserv,
  hide_link_infoserv_info,
  hide_link_infoserv_serv,
  hide_link_infoserv_faq,
  hide_link_infoserv_contact,
  all_in_one_tab,
  closeParent,
  openSettings,
  logoutAction,
}) => {
  getMenuCounters().then((menuCounters) => {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    user.counters = menuCounters;
    localStorage.setItem("user", JSON.stringify(user));
  });

  const { counters } = JSON.parse(localStorage.getItem("user")) || {};

  return <DropdownMenu right>
    {!hide_link_add_course && (
      <a
        href={`${path}/trainings/add`}
        style={
          permissions.includes("TRAINING_ADD")
            ? {}
            : { pointerEvents: "none", opacity: "0.65" }
        }
        target={all_in_one_tab ? "_self" : "_blank"}
        rel="noreferrer"
      >
        <DropdownItem>
          <i className="icon_c_m icon_c_bg icon_add_training" />
          <FormattedMessage id="header_training_create" />
        </DropdownItem>
      </a>
    )}
    {!hide_link_my_courses && (
      <Link to="/trainings" target={all_in_one_tab ? "_self" : "_blank"}>
        <DropdownItem>
          <i className="icon_c_m icon_c_bg icon_trainings" />
          <FormattedMessage id="trainings_list_myTrainings" />
          {!!counters.new_trainings && (
            <Indicator>{counters.new_trainings}</Indicator>
          )}
        </DropdownItem>
      </Link>
    )}
    {!hide_link_my_chats && (
      <a
        href={
          allow_chat
            ? "/learning/#/trainings/chats"
            : "javascript: return false;"
        }
        disabled={!allow_chat}
        target={all_in_one_tab ? "_self" : "_blank"}
        rel="noreferrer"
      >
        <DropdownItem disabled={!allow_chat}>
          <i className="icon_c_m icon_c_bg icon_chats" />
          <FormattedMessage id="trainings_list_myChats" />
          {!!counters.unread_chats && allow_chat && (
            <Indicator disabled={!allow_chat}>
              {counters.unread_chats}
            </Indicator>
          )}
        </DropdownItem>
      </a>
    )}
    {!hide_link_my_certs && (
      <Link to="/trainings/certificates" target={all_in_one_tab ? "_self" : "_blank"}>
        <DropdownItem>
          <i className="icon_c_m icon_c_bg icon_cert" />
          <FormattedMessage id="trainings_list_myCertificates" />
          {!!counters.new_certificates && (
            <Indicator>{counters.new_certificates}</Indicator>
          )}
        </DropdownItem>
      </Link>
    )}
    {!hide_link_my_picts && (
      <Link to="/trainings/pictures" target={all_in_one_tab ? "_self" : "_blank"}>
        <DropdownItem>
          <i className="icon_c_m icon_c_bg icon_images" />
          <FormattedMessage id="lessons_myPictures" />
        </DropdownItem>
      </Link>
    )}
    {!hide_link_my_notes && (
      <Link to="/trainings/notes" target={all_in_one_tab ? "_self" : "_blank"}>
        <DropdownItem>
          <i className="icon_c_m icon_c_bg icon_notes" />
          <FormattedMessage id="lessons_myNotes" />
        </DropdownItem>
      </Link>
    )}
    {!hide_link_change_pass && (
      <Link to="/change-password" target={all_in_one_tab ? "_self" : "_blank"}>
        <DropdownItem>
          <i className="fa fa-shield" />
          <FormattedMessage id="header_profile_changePassword" />
        </DropdownItem>
      </Link>
    )}
    {!hide_link_infoserv && (
      <DropdownInfo
        closeParent={closeParent}
        hide_link_infoserv_info={hide_link_infoserv_info}
        hide_link_infoserv_serv={hide_link_infoserv_serv}
        hide_link_infoserv_faq={hide_link_infoserv_faq}
        hide_link_infoserv_contact={hide_link_infoserv_contact}
        all_in_one_tab={all_in_one_tab}
      />
    )}
    {!hide_link_settings && (
      <DropdownItem onClick={openSettings}>
        <i className="icon_c_m icon_c_bg icon_settings" />
        <FormattedMessage id="header_profile_settings" />
      </DropdownItem>
    )}
    <DropdownItem style={{ textAlign: "right" }} onClick={logoutAction}>
      <FormattedMessage id="header_profile_logout" />
      <i className="fa fa-power-off" style={{ margin: "0 0 0 10px" }} />{" "}
    </DropdownItem>
  </DropdownMenu>;
};

Menu.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  closeParent: PropTypes.func.isRequired,
  openSettings: PropTypes.func.isRequired,
  logoutAction: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/_Header/_dropdownMenu.js